<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- faq_wrap -->
            <div class="create_wrap">
                <table class="create_table">
                    <colgroup>
                        <col width="154" />
                        <col width="*" />
                    </colgroup>
                    <caption>
                        <em class="txt_mandatory">*</em>
                        {{
                            $t('FIELD.GLOBAL.MANDATORY')
                        }}
                    </caption>
                    <tr>
                        <th>
                            {{ $t('FIELD.GLOBAL.INQUIRY') }}
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <fieldset class="ui_fieldset set_3">
                                <div>
                                    <select
                                        class="slt_white w100p"
                                        v-model="inquiry1Code"
                                        @change="inquiryList(2)"
                                        :disabled="!isNull(faq_id) && isNull(inquiry2Code)"
                                    >
                                        <option value>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in inquiry1CodeList"
                                            :key="pageName + item.CD"
                                            :value="item.CD"
                                            >{{ item.CD_NAME }}</option
                                        >
                                    </select>
                                </div>
                                <div>
                                    <select
                                        class="slt_white w100p"
                                        v-model="inquiry2Code"
                                        :disabled="!isNull(faq_id) && isNull(inquiry2Code)"
                                    >
                                        <option value>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in inquiry2CodeList"
                                            :key="pageName + item.CD"
                                            :value="item.CD"
                                            >{{ item.CD_NAME }}</option
                                        >
                                    </select>
                                </div>
                            </fieldset>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t('FIELD.FAST.ADVANCED.MODEL') }}
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <fieldset class="ui_fieldset">
                                <label class="serach-wrap">
                                    <input
                                        type="text"
                                        class="text_input cur_pointer"
                                        :placeholder="$t('BUTTON.GLOBAL.SEARCH')"
                                        v-model="modelNm"
                                        @click="searchModelPopup()"
                                        readonly
                                    />
                                    <a class="in_btn_search">
                                        <i class="ico_input_serach"></i>
                                        <span class="sr_only"></span>
                                    </a>
                                </label>
                                <label class="checkbox-wrap">
                                    <input type="checkbox" @click="clearModel()" v-model="modelCheck" checked />
                                    <i class="check-icon"></i>
                                    <em>{{ $t('FIELD.FAQ.NOT.RELEVANT') }}</em>
                                </label>
                            </fieldset>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t('FIELD.GLOBAL.CATEGORY') }}
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <fieldset class="ui_fieldset set_3">
                                <label class="select-wrap">
                                    <select
                                        class="slt_white w100p"
                                        id="category1Code"
                                        v-model="category1Code"
                                        @change="categoryList(2)"
                                        :disabled="!modelCheck"
                                    >
                                        <option
                                            v-for="item in category1CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                            >{{ item.codeName }}</option
                                        >
                                    </select>
                                </label>
                                <label class="select-wrap">
                                    <select
                                        class="slt_white w100p"
                                        id="category2Code"
                                        v-model="category2Code"
                                        @change="categoryList(3)"
                                        :disabled="!modelCheck"
                                    >
                                        <option
                                            v-for="item in category2CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                            >{{ item.codeName }}</option
                                        >
                                    </select>
                                </label>
                                <label class="select-wrap">
                                    <select
                                        class="slt_white w100p"
                                        id="category3Code"
                                        v-model="category3Code"
                                        :disabled="!modelCheck"
                                    >
                                        <option
                                            v-for="item in category3CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                            >{{ item.codeName }}</option
                                        >
                                    </select>
                                </label>
                            </fieldset>
                        </td>
                    </tr>
                    <tr v-if="'C550' === corpCd || 'WA' === corpCd">
                        <th>
                            {{ $t('FIELD.GLOBAL.SEARCHKEYWORD') }}
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100p" v-model="searchKeyword" v-clearable />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t('FIELD.GLOBAL.IMPORTANT') }}
                            <em class="ico_info">
                                <i class="tooltip">{{ $t('FIELD.GLOBAL.ETC.058') }}</i>
                            </em>
                        </th>
                        <td>
                            <label class="checkbox-wrap">
                                <input type="checkbox" v-model="gradeCode" true-value="S" false-value />
                                <i class="check-icon"></i>
                                <em>{{ $t('FIELD.GLOBAL.IMPORTANT') }}</em>
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t('FIELD.GLOBAL.TITLE') }}
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="clearable">
                                <input type="text" class="text_input w100p" v-model="title" v-clearable />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t('FIELD.GLOBAL.QNA.DESC') }}
                            <em class="txt_mandatory">*</em>
                            <a
                                href="javascript:"
                                class="ico_write_global"
                                @click="openNamoClick('questionDesc')"
                                v-if="'solutionDesc' === openNamo"
                            >
                                <span class="sr_only"></span>
                            </a>
                        </th>
                        <td>
                            <cross-editor
                                editorId="questionDesc"
                                :editorData="questionDesc"
                                v-if="'questionDesc' === openNamo"
                            ></cross-editor>
                            <div class="namoClass" v-html="questionDesc" v-if="'solutionDesc' === openNamo"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t('FIELD.GLOBAL.ANS.DESC') }}
                            <em class="txt_mandatory">*</em>
                            <a
                                href="javascript:"
                                class="ico_write_global"
                                @click="openNamoClick('solutionDesc')"
                                v-if="'questionDesc' === openNamo"
                            >
                                <span class="sr_only"></span>
                            </a>
                        </th>
                        <td>
                            <cross-editor
                                editorId="solutionDesc"
                                :editorData="solutionDesc"
                                v-if="'solutionDesc' === openNamo"
                            ></cross-editor>
                            <div class="namoClass" v-html="solutionDesc" v-if="'questionDesc' === openNamo"></div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.GLOBAL.ATTACHMENT') }}</th>
                        <td class="no_padding">
                            <innorix-upload
                                :uploadId="pageName"
                                :id="pageName"
                                :name="pageName"
                                :serviceType="serviceType"
                                :onlyUpload="onlyUpload"
                                :attachList="attach"
                                @files="setFiles"
                            />
                        </td>
                    </tr>
                </table>
            </div>
            <div class="btn_wrap_full topLine">
                <a href="javascript:" class="btn_white size_full" @click="pageMove($route.name)" v-if="faq_id">List</a>
                <div class="btn_right" v-if="'' === faq_id || 'Y' === params.creationYn">
                    <a href="javascript:" class="btn_white" @click="faqDel()" v-if="faq_id">{{
                        $t('BUTTON.GLOBAL.DELETE')
                    }}</a>
                    <a href="javascript:" class="btn_blue" @click="save(0)">{{ $t('BUTTON.GLOBAL.REGISTER') }}</a>
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import { SDLUtil, StringUtil, DateUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';
import api from '@/service';
import searchModelPopup from '~vb/faq/popup/searchModelPopup';
import CrossEditor from '~c/CrossEditor';
import InnorixUpload from '~c/InnorixUpload';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import { EventBus } from '@/utils/EventBus';

export default {
    name: 'createNewFAQ',
    components: {
        'cross-editor': CrossEditor,
        'innorix-upload': InnorixUpload,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    data() {
        return {
            pageName: this.$route.name,
            pageTitle: '',
            inquiry1Code: '',
            inquiry2Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],
            category1Code: '',
            category2Code: '',
            category3Code: '',
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
            modelCd: '',
            modelNm: '',
            modelCheck: true,
            title: '',
            questionDesc: '',
            solutionDesc: '',
            serviceType: 'common',
            attach: [],
            onlyUpload: false,
            userNo: '',
            searchKeyword: '',
            gradeCode: '',
            faq_id: '',
            openNamo: 'questionDesc',
            attachFileSeq: [],
            delAttachFiles: [],
            isRemove: false,
        };
    },
    mounted() {
        this.inquiryList(1);
        this.categoryList(1);
        if (!SDLUtil.isNull(this.getFaqId)) {
            this.searchDetail(this.getFaqId);
        }
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            supportSnbParams: 'getSupportSnbParams',
            menus: 'getMenus',
            params: 'getParams',
        }),
        getFaqId() {
            let faq_id = this.$route.query.faq_id || '';
            return faq_id;
        },
    },
    watch: {
        supportSnbParams() {
            this.initializeSearch();
        },
    },
    methods: {
        //function start
        //initialize start
        async initializeSearch() {
            if (SDLUtil.isNull(this.supportSnbParams.faqType)) {
                this.inquiry1Code = this.supportSnbParams.faqInquiry1Code;
                this.inquiry2Code = this.supportSnbParams.faqInquiry2Code;
                this.category1Code = this.supportSnbParams.faqCategory1Code;
                this.category2Code = this.supportSnbParams.faqCategory2Code;
                this.inquiryList(2);
                this.categoryList(2);
            } else if ('I' === this.supportSnbParams.faqType) {
                this.inquiry1Code = this.supportSnbParams.faqInquiry1Code;
                this.inquiry2Code = this.supportSnbParams.faqInquiry2Code;
                this.inquiryList(2);
            } else if ('C' === this.supportSnbParams.faqType) {
                this.category1Code = this.supportSnbParams.faqCategory1Code;
                this.category2Code = this.supportSnbParams.faqCategory2Code;
                this.categoryList(2);
            }
        },
        //initialize end
        //search option start
        //search option end

        //search area start
        async inquiryList(v) {
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: 'inquiryType' + v,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.corpCd,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1CodeList = resp.data.result.rowData;
                        this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2CodeList = resp.data.result.rowData;
                        let code = this.inquiry2Code;
                        if (!SDLUtil.isNull(code)) {
                            const idx = this.inquiry2CodeList.findIndex(function(item) {
                                return item.CD === code;
                            });
                            if (0 > idx) {
                                if (!SDLUtil.isNull(this.inquiry2CodeList[0]) && SDLUtil.isNull(this.inquiry2Code)) {
                                    this.inquiry2Code = this.inquiry2CodeList[idx].CD;
                                } else {
                                    this.inquiry2Code = '';
                                }
                            }
                        }
                    }
                });
        },
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category1CodeList = resp;
                    if (!SDLUtil.isNull(resp[0]) && SDLUtil.isNull(this.category1Code)) {
                        this.category1Code = resp[0].code;
                    }
                    this.categoryList(2);
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2CodeList = [];
                this.category3CodeList = [];
                let code = this.category2Code;
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category2CodeList = resp;
                    const idx = resp.findIndex(function(item) {
                        return item.code === code;
                    });
                    if (0 > idx) {
                        if (!SDLUtil.isNull(resp[0])) {
                            this.category2Code = resp[0].code;
                        } else {
                            this.category2Code = '';
                        }
                    }
                    this.categoryList(3);
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3CodeList = [];
                let code = this.category3Code;
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category3CodeList = resp;
                    const idx = resp.findIndex(function(item) {
                        return item.code === code;
                    });
                    if (0 > idx) {
                        if (!SDLUtil.isNull(resp[0])) {
                            this.category3Code = resp[0].code;
                        } else {
                            this.category3Code = '';
                        }
                    }
                });
            }
        },
        searchModelPopup() {
            let searchModel = this.modelNm;
            SDLUtil.show(
                searchModelPopup,
                {
                    searchModel,
                    rtnFunc: (arg1, arg2, arg3, arg4, arg5) => {
                        this.modelCd = arg1;
                        this.modelNm = arg2;
                        this.modelCheck = false;
                        this.category1Code = arg3;
                        this.category2Code = arg4;
                        this.category2Code = arg5;
                        this.categoryList(2);
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        clearModel() {
            if (!this.modelCheck) {
                this.modelCd = '';
                this.modelNm = '';
            }
        },
        async searchDetail(v) {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/faq/faqDetail.skp`, qs.stringify({ FAQ_ID: v }))
                .then(resp => {
                    let detail = resp.data.detail.rowData[0];
                    this.gradeCode = detail.GRADE;
                    this.faq_id = detail.FAQ_ID;
                    this.modelCd = detail.MODEL_CD;
                    this.modelNm = detail.MODEL_NM;
                    this.searchKeyword = detail.SEARCHKEYWORD;
                    this.title = detail.TITLE;
                    this.questionDesc = detail.QUESTION_DESC;
                    this.solutionDesc = detail.SOLUTION_DESC;
                    this.userNo = detail.MODF_USER_NO;
                    this.attach = resp.data.attach.rowData;

                    this.inquiry1Code = SDLUtil.nvl(detail.INQUIRY_TYPE1);
                    this.inquiry2Code = SDLUtil.nvl(detail.INQUIRY_TYPE2);
                    this.category1Code = SDLUtil.nvl(detail.PRD_CATEGORY_CD1);
                    this.category2Code = SDLUtil.nvl(detail.PRD_CATEGORY_CD2);
                    this.category3Code = SDLUtil.nvl(detail.PRD_CATEGORY_CD3);
                    this.inquiryList(2);
                    this.categoryList(2);

                    if (!SDLUtil.isNull(this.modelCd)) {
                        this.modelCheck = false;
                    }

                    EventBus.$emit('innorix-reset-file-list', {
                        uploadId: this.pageName,
                        fileList: this.attach,
                    });

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        //search area end

        //page move start
        pageMove(v) {
            // if ('createNewFAQ' === v || 'createNewQuestion' === v) {
            return this.$router.push(MenuUtil.getSupportMain());
            // }
        },
        //page move end

        //save start
        save(v) {
            let MENDATORY = SDLUtil.getMsgProp('MESSAGE.FIELD.CHECK.MENDATORY');
            let LENGTH = SDLUtil.getMsgProp('MESSAGE.DATA.MAX.LENGTH');

            if (('C550' === this.corpCd || 'WA' === this.corpCd) && 0 === SDLUtil.textLength(this.searchKeyword)) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.FAQ.SEARCHKEYWORD'));
                return false;
            } else if (0 === SDLUtil.textLength(this.title)) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.TITLE')));
                return false;
            } else if (!SDLUtil.lengthCheck(this.title, 300)) {
                //FIELD.GLOBAL.SEARCHKEYWORD
                SDLUtil.alert('[' + SDLUtil.getMsgProp('FIELD.GLOBAL.TITLE') + ']' + LENGTH.replace('{0}', '300'));
                return false;
            } else if (!SDLUtil.lengthCheck(this.searchKeyword, 1000)) {
                SDLUtil.alert(
                    '[' + SDLUtil.getMsgProp('FIELD.GLOBAL.SEARCHKEYWORD') + ']' + LENGTH.replace('{0}', '1000'),
                );
                return false;
            } else if (SDLUtil.isNull(this.inquiry1Code)) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY')));
                return false;
            } else if (
                SDLUtil.isNull(this.category1Code) ||
                SDLUtil.isNull(this.category2Code) ||
                SDLUtil.isNull(this.category3Code)
            ) {
                SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY')));
                return false;
            }

            if ('solutionDesc' === this.openNamo) {
                if (SDLUtil.isNull(this.questionDesc)) {
                    SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.QNA.DESC')));
                    return false;
                } else if (0 === SDLUtil.textLength(window.solutionDesc.GetTextValue())) {
                    SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.ANS.DESC')));
                    return false;
                } else {
                    this.solutionDesc = window.solutionDesc.GetBodyValue('XHTML');
                }
            } else {
                if (0 === SDLUtil.textLength(window.questionDesc.GetTextValue())) {
                    SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.QNA.DESC')));
                    return false;
                } else if (SDLUtil.isNull(this.solutionDesc)) {
                    SDLUtil.alert(MENDATORY.replace('{0}', SDLUtil.getMsgProp('FIELD.GLOBAL.ANS.DESC')));
                    return false;
                } else {
                    this.questionDesc = window.questionDesc.GetBodyValue('XHTML');
                }
            }

            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.SAVE.CONFIRM'),
                // title: SDLUtil.getMsgProp('BUTTON.GLOBAL.REGISTER'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    let url = `${SDLUtil.API_URL}/basis/faq/save.skp`;
                    return axios
                        .post(
                            url,
                            qs.stringify({
                                FAQ_ID: this.faq_id,
                                INQUIRY_TYPE1: this.inquiry1Code,
                                INQUIRY_TYPE2: this.inquiry2Code,
                                modelCd: this.modelCd,
                                PRD_CATEGORY_CD1: this.category1Code,
                                PRD_CATEGORY_CD2: this.category2Code,
                                PRD_CATEGORY_CD3: this.category3Code,
                                GRADE: this.gradeCode,
                                searchKeyword: this.searchKeyword,
                                TITLE: this.title,
                                QUESTION_DESC: this.questionDesc,
                                SOLUTION_DESC: this.solutionDesc,
                                REG_USER_NO: this.loginNo,
                                MODF_USER_NO: this.loginNo,
                                CORP_NO: this.corpCd,
                                attachFileSeq: this.attachFileSeq.map(item => item.attachFileSeq),
                                delAttachFiles: this.delAttachFiles.map(item => item.attachFileSeq),
                                isRemove: this.isRemove,
                            }),
                        )
                        .then(resp => {
                            this.faq_id = resp.data.faq_id;
                            SDLUtil.alert(resp.data.msg);
                            SDLUtil.showLoadingBar(false);
                            if (SDLUtil.isNull(this.faq_id)) return false;
                            return this.pageMove(this.$route.name);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        faqDel() {
            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.DELETE.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/faq/delete.skp`,
                            qs.stringify({
                                FAQ_ID: this.faq_id,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.alert(resp.data.msg);
                            SDLUtil.showLoadingBar(false);
                            return this.pageMove(this.$route.name);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        //save end

        //etc start
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.corpCd);
            return codeResp;
        },
        openNamoClick(v) {
            if ('solutionDesc' === v) {
                this.questionDesc = window.questionDesc.GetBodyValue('XHTML');
            } else {
                this.solutionDesc = window.solutionDesc.GetBodyValue('XHTML');
            }
            this.openNamo = v;
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        setFiles(val) {
            this.attachFileSeq = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },
        isNull(val) {
            return SDLUtil.isNull(val);
        },
        //etc end
        //function end
    },
};
</script>

<style scoped>
.namoClass {
    width: 100%;
    min-height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/createNewFAQ.vue